<h2 mat-dialog-title>Filtro avançados</h2>

<mat-dialog-content class="filters-grid" [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>Médico</mat-label>
    <mat-select formControlName="doctorId">
      <mat-option [value]="null">Todos</mat-option>
      <mat-option
        *ngFor="let doctor of doctors"
        [value]="doctor.id"
      >
        {{ doctor.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="apply()">
    Aplicar filtro
  </button>
</mat-dialog-actions>
